<template>
      <section>
        <v-parallax :src="require('@/assets/immobiliariaAparador.jpg')" height="600">
          <v-layout
            align-center
            justify-center
            class="white--text"
          >
            <v-flex md6 xs12>
              <div id="searchBox">
                <v-layout
                align-center
                justify-center
                row
                wrap
                class="white--text">
                <v-flex md12 xs12>
                  <div class="text-xs-center">
                    <h1 class="headline mainTitle strongTextWithCustomFont">ENCUENTRA TU NUEVO HOGAR</h1>
                  </div>
                </v-flex>
                <v-flex md12 xs12>
                  <v-autocomplete
                    label="Población"
                    v-model="selectedTowns"
                    color="primary"
                    :items="usedTowns"
                    item-text="name"
                    solo
                    ligth
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <h3 class="secondaryTitle headline"> ¿ Que buscas ? </h3>
                  </div>
                </v-flex>
                <v-flex xs12 class="pb-3">
                  <div class="text-xs-center">
                    <big-bool-selector @isForRentChanged="isForRentChanged"/>
                  </div>
                </v-flex>
                <v-flex md12 xs12>
                  <v-btn block color="primary" @click="search">Buscar</v-btn>
                </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-parallax>
      </section>
</template>

<script>
import BigBoolSelector from '@/components/bigSelector.vue';
import { GET_USED_TOWNS, GET_PUBLIC_PROPERTIES } from '../constants'

export default {
  components: {
    BigBoolSelector,
  },
  async mounted() {
    this.items = await this.$store.dispatch(GET_USED_TOWNS);
  },
  computed : {
    usedTowns: function() {
      return this.$store.state.usedTowns;
    }
  },
  data: () => {
      return {
      selectedTowns: [],
      isLoading: false,
      isForRent: true,
    }
  },
  methods: {
    search () {
      this.selectedTowns = [ this.selectedTowns ];
      this.$router.push({ path: '/search', query: { towns: this.selectedTowns, isForRent: this.isForRent }})
    },
    isForRentChanged (value) {
      this.isForRent = value;
    }
  }
};
</script>

<style scoped>
.strongTextWithCustomFont {

}
</style>
